module.exports = __webpack_public_path__ + "57dfadee3049ba9fe1d0427ffa2826cb.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/ipad.png
// module id = 684
// module chunks = 0